// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as RouterProvider$Showside from "../../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../../context/ViewportContext.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
function NavMenu__Backdrop(Props) {
  var ctx = NavMenu__Context$Showside.use(undefined);
  var match = RouterProvider$Showside.useRouter(undefined);
  var goTo = match.goTo;
  var match$1 = ViewportContext$Showside.use(undefined);
  var windowHeight = match$1.windowSize.height;
  var timeoutRef = React.useRef(undefined);
  var match$2 = ctx.mode;
  var match$3 = match$2 ? [0, windowHeight] : [ctx.positions.siteHeaderSize.height + ctx.positions.siteHeaderSize.top | 0, windowHeight - (ctx.positions.siteHeaderSize.height + ctx.positions.siteHeaderSize.top | 0) | 0];
  var $$clearTimeout$1 = function (param) {
    Belt_Option.forEach(timeoutRef.current, function (prim) {
      clearTimeout(prim);
    });
  };
  var handleCloseStart = function (param) {
    $$clearTimeout$1(undefined);
    timeoutRef.current = Caml_option.some(setTimeout(function (param) {
      Curry._3(goTo, undefined, undefined, /* NotRendered */0);
    }, 50));
  };
  var handleCloseCancel = function (param) {
    $$clearTimeout$1(undefined);
  };
  var match$4 = ctx.mode;
  var handleClick = match$4 ? handleCloseStart : undefined;
  var match$5 = ctx.mode;
  var handleMouseEnter = match$5 ? undefined : handleCloseStart;
  var match$6 = ctx.mode;
  var handleMouseLeave = match$6 ? undefined : handleCloseCancel;
  React.useEffect(function () {
    return $$clearTimeout$1;
  }, []);
  var zIndex = ctx.zIndex > 0 ? ctx.zIndex - 1 | 0 : undefined;
  if (zIndex === undefined) {
    return null;
  }
  var tmp = {
    className: CSS$Showside.prefix(Cn.make(["transition-opacity", "fixed bg-black left-0 w-full", ctx.isModalOpen ? "" : "pointer-events-none"])),
    style: {
      height: CSS$Showside.intToPx(match$3[1]),
      top: CSS$Showside.intToPx(match$3[0]),
      zIndex: String(ctx.zIndex - 1 | 0),
      opacity: ctx.isModalOpen ? ctx.modalBackdropOpacity.toString() : "0",
      transitionDuration: CSS$Showside.intToMs(ctx.modalTransitionSpeedMs)
    }
  };
  if (handleClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(handleClick);
  }
  if (handleMouseEnter !== undefined) {
    tmp.onMouseEnter = Caml_option.valFromOption(handleMouseEnter);
  }
  if (handleMouseLeave !== undefined) {
    tmp.onMouseLeave = Caml_option.valFromOption(handleMouseLeave);
  }
  return React.createElement("div", tmp);
}
NavMenu__Backdrop.displayName = "NavMenu__Backdrop";
var make = NavMenu__Backdrop;
export { make };
/* react Not a pure module */